// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
//import ElementUI from 'element-ui'
import api from './apis'
import jquery from 'jquery'
import utils from './utils'
import installCostCenterI18n from './utils/costCenterI18n'
import router from './router'
import { mapGetters } from 'vuex'
// import 'element-ui/lib/theme-default/index.css'
// import 'element-ui/lib/theme-default/row.css'
// import 'element-ui/lib/theme-default/col.css'
// import 'normalize.css'
import './assets/main.css'
import './assets/layout.css'

import store from './store/store'
import icon from './views/modules/icon'
import layout from './views/modules/layout'
import bmain from './views/modules/back-main'
import fmain from './views/modules/front-main'
import wrapper from './views/modules/wrapper'
import pagenav from './views/modules/page-nav'
import keepStatus from './views/modules/keep-status.vue'
import CN from './lang/CN'
import EN from './lang/EN'
import JP from './lang/JP'
import filter from './filter.js'
import customerServices from './views/modules/customer-services.vue'
// import {
//     lang
// } from 'moment';

// Vue.use(ElementUI)
window.$ = window.jquery = jquery
Vue.prototype.$api = api;
Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.prototype.getImgs = function (path, type) {
    var reg = /^www./g;
    let hostname = window.location.hostname;
    if (!reg.test(hostname)) {
        hostname = 'www.lchtrip.com';
    }
    if (!type || type == 'img') {
        return `/static/${hostname.replace(/\./g,'')}/imgs/${path}`;
    } else {
        return `url(/static/${hostname.replace(/\./g,'')}/imgs/${path})`;
    }
}
// api.system.getActionList().
// then(function(response) {
//     console.log(`then ${response.data.message}`)
// }).catch(function(response) {
//     console.log(`catch ${response.message}`)
// })

/*
 *icon.name 应该是可以的，暂时不确定是什么原因导致这里读不到icon.name 
 *Vue.component(icon.name, icon)
 */
Vue.component("icon", icon);
Vue.component("l-layout", layout);
Vue.component("b-main", bmain);
Vue.component("f-main", fmain);
Vue.component("wrapper", wrapper);
Vue.component("pagenav", pagenav);
Vue.component("keep-status", keepStatus);
Vue.component("customer-services", customerServices);

// import VueI18n from 'vue-i18n'

// Vue.use(VueI18n);

/* eslint-disable no-new */
let home = router.options.routes[0];
let historys = [{
    path: home.path,
    name: home.name
}];

function checkState(isTips, store, to, callback) {
    let requiresAuth = _.find(to.matched, o => o.meta.requiresAuth);
    let isRedirect = requiresAuth !== undefined;
    if (document.cookie.indexOf("SfsSes") == -1 && !sessionStorage.getItem("SfsSes")) {
        callback(isRedirect);
        return;
    } else if (store.getters.ticketInfo.UserID !== undefined) {
        callback(false);
        return;
    }
    if (!isRedirect) {
        callback(false);
    }
    return store.dispatch('loadTicketInfo', {
        failTips: false
    }).then(function (response) {
        if (response.data.isSucc === true) {
            if (isRedirect)
                callback(false);
            return response;
        }
        return store.dispatch("logout").then(function () {
            if (isRedirect)
                callback(isRedirect);
        });
    }).catch(function (response) {
        if (isRedirect)
            callback(isRedirect);
    });
}

router.beforeEach((to, from, next) => {
    checkState(false, store, to, function (isRedirect) {
        if (isRedirect === true) {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            });
            return;
        }
        var lastHistory = historys[historys.length - 1];
        if (from.path == lastHistory.path) {
            lastHistory.scrollTop = $(".page").scrollTop();
        }
        next();
    });

})
const i18n = new VueI18n({
    locale: window.localStorage.getItem('lang') ? window.localStorage.getItem('lang') : 'cn',
    messages: {
        en: EN,
        cn: CN,
        jp: JP,
    }
})

installCostCenterI18n(Vue, i18n, store);

const app = new Vue({
    router,
    store,
    i18n,
    data() {
        return {
            transitionName: "slide-left",
            TriptList: {},
            FeatureCodes: null
        }
    },
    computed: {
        ...mapGetters(['actions', 'siteInfo']),
        keepAlive() {
            var keepAlive = historys.map(function (router) {
                return (router.name || router.path).replace('/', '');
            }).join(',');
            return keepAlive;
        },
        HideHearder() {
            return this.$route.query;
        }
    },
    watch: {
        '$route'(to, from) {
            // let historys = this.historys;
            if (historys[historys.length - 1].path == to.path)
                return;
            var isBack = historys.length < 2 ? false : to.path == historys[historys.length - 2].path;
            if (isBack) {
                historys.pop();
            } else {
                historys.push({
                    path: to.path,
                    name: to.name
                });
            }
            this.transitionName = isBack ? 'slide-right' : 'slide-left';

            this.changeAction(to.matched, to);
        },
        'actions'() {
            this.changeAction(this.$route.matched, this.$route);
        },
        'siteInfo'() {
            if (!document.title && document.title == '') {
                document.title = this.siteInfo && this.siteInfo.SystemName || document.title;
            }
        },
        '$i18n.locale'(newVal, ) {
            if (newVal) {
                // let cookies = document.cookie.split(";");
                // for (var i = 0; i < cookies.length; i++) {
                //     var cookie = cookies[i];
                //     if (cookie.indexOf("lang") > -1) {
                //         cookie.trim();
                //         document.cookie = "lang=" + newVal
                //     }
                // }
                this.SaveCookie(newVal)
            }


        },

    },
    methods: {
        SaveCookie(value) {
            document.cookie = `lang=${value};path=/;`;
        },
        changeAction(matched, target) {
            let route = _.last(matched);
            let clears = store.getters.clears;
            let path = target.fullPath;
            let acts = _(clears).filter(o => o.IdentifyPath.toUpperCase() == route.path.toUpperCase())
                .orderBy(o => {
                    try {
                        let matchs = utils.compare(o.IdentifyCode.toUpperCase(), path.toUpperCase());
                        // console.log(`${path.toUpperCase()} ${o.IdentifyCode.toUpperCase()} ${matchs}`);
                        return matchs;
                    } catch (e) {
                        console.log(`${path.toUpperCase()} ${o.IdentifyCode.toUpperCase()} exception`);
                    }
                    return path.toUpperCase().indexOf(o.IdentifyCode.toUpperCase());
                });
            // acts = acts.orderBy(o => utils.compare(o, path));
            store.dispatch("changeCurrentAction", acts.first());
        }
    },
    mounted() {
        let __self = this;
        // __self.FeatureCodes = __self.$route.query.FeatureCodes;
        // console.log(__self.FeatureCodes)
        __self.FeatureCodes = location.search.indexOf('HideHeader');

        // $.cookie('lang', this.$i18n.locale, {
        //     path: '/'
        // })
        this.SaveCookie(this.$i18n.locale)
        // document.cookie = "lang=" + this.$i18n.locale;
        store.dispatch("loadSiteInfo").then(function (json) {
            // console.log(json);
        });
        $("link[rel=icon]").attr("href", __self.getImgs('icon.ico'))
    }
});
app.$mount('#app');
// let loadingInstance = app.$loading({
//     text: '正在加载'
// });

// setTimeout(function () {
//     loadingInstance.close();
// }, 1000);
Date.prototype.toJSON = function () {
    return utils.DateFormat(this, "yyyy-MM-dd HH:mm:ss")
}
window.DefaultCompanyID = "S00000010159"
window.$app = app

document.body.ontouchmove = function (e) {
    e.preventDefault()
}
$(".page").on("touchmove", function (e) {
    e.stopPropagation();
});


$(document).on("mousewheel", ".el-scrollbar__wrap", function (e) {
    var t = e.currentTarget;
    if ((t.scrollHeight < t.scrollWidth + 5) || (e.originalEvent.deltaY > 0 && t.scrollWidth == t.scrollTop) || (e.originalEvent.deltaY < 0 && t.scrollTop == 0)) {
        return false;
    }
});



// WEBPACK FOOTER //
// ./src/main.js